import { render, staticRenderFns } from "./DafXFDashboard.vue?vue&type=template&id=2b312b02&"
import script from "./DafXFDashboard.vue?vue&type=script&lang=js&"
export * from "./DafXFDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports